import { designService } from '@paragon/data-connections';
import { getLoggedInUserOrganization } from '@paragon/login-tools';
import { loadCurrentOrganizationMaterialSet } from '@paragon/material-lists';

import { AsyncThunkActionVoid } from './thunkActionTypes';

export const setDefaultLumberListGuid =
  (lumberListGuid: string): AsyncThunkActionVoid =>
  async (dispatch, getState) => {
    const state = getState();
    const organization = getLoggedInUserOrganization(state);

    if (organization == null) throw new Error('Unauthenticated user attempted to edit default material selection.');

    await designService.materialLists.setDefaultLumberListGuid(organization, lumberListGuid);
    await dispatch(loadCurrentOrganizationMaterialSet());
  };

export const setDefaultPlateListGuid =
  (plateListGuid: string): AsyncThunkActionVoid =>
  async (dispatch, getState) => {
    const state = getState();
    const organization = getLoggedInUserOrganization(state);

    if (organization == null) throw new Error('Unauthenticated user attempted to edit default material selection.');

    await designService.materialLists.setDefaultPlateListGuid(organization, plateListGuid);
    await dispatch(loadCurrentOrganizationMaterialSet());
  };

export const setDefaultHangerListGuid =
  (hangerListGuid: string): AsyncThunkActionVoid =>
  async (dispatch, getState) => {
    const state = getState();
    const organization = getLoggedInUserOrganization(state);

    if (organization == null) throw new Error('Unauthenticated user attempted to edit default material selection.');

    await designService.materialLists.setDefaultHangerListGuid(organization, hangerListGuid);
    await dispatch(loadCurrentOrganizationMaterialSet());
  };
